export default "__VITE_ASSET__BJMNeeFj__"